<template>
  <div class="pageHome">
    <div class="menu">
      <van-icon name="apps-o" size="1.5em" class="menuBtn" @click="handleMenuOpen" color="#2ad1c4"/>
      <span style="color: #8f8d8d">{{$store.getters.userName}}</span>
      <van-icon name="close" size="1.5em" class="menuBtn" @click="handleExit" color="#2ad1c4" />
    </div>
    <router-view></router-view>
    <van-popup v-model="show" position="left" :style="{ height: '100%', width: '30%' }" get-container="body">
      <van-icon name="wap-home-o" size="2em" :style="{ padding: '12px' }" />
      <van-sidebar v-model="activeKey" class="sideBar">
        <van-sidebar-item v-for="item in routes" :title="item.meta.title" @click="handleClick(item.path)" :key="item.path" />
      </van-sidebar>
    </van-popup>
  </div>

</template>

<script>
import { Dialog } from 'vant';


export default {
  name: "index",
  data(){
    return {
      show: false, // 是否展示左侧菜单
      activeKey: 0, // 激活菜单序列号
      routes: JSON.parse(localStorage.getItem('routes'))[0].children
      // routes: [], // 左侧菜单
    }
  },
  mounted() {
    // 确保是重新登录过，获取了是否有权限的,否则强制登录一次
    // const canSeeStatic = localStorage.getItem('isShowStatic');
    // if(!canSeeStatic){
    //   this.$router.replace('/login')
    // }
    // const all = JSON.parse(localStorage.getItem('routes'));
    // const sideBar = all.filter(val => {
    //   return !val.hidden
    // })
    // // console.log(all)
    // // console.log(sideBar)
    // // this.routes = sideBar[0].children
    // // 在这里判断是不是能看展示驾驶舱的菜单
    // if(canSeeStatic === 'true') {
    //   this.routes = sideBar[0].children
    // } else {
    //   this.routes = sideBar[0].children.filter(val => {
    //     return !val.isAuth
    //   })
    // }

    // console.log(all)
    console.log(this.routes)
  },
  methods: {
    handleMenuOpen(){ // 打开左侧菜单栏
      this.show = true;
    },
    handleExit(){ // 退出到登录页
      const _this = this;
      Dialog.confirm({
        message: '确认退出吗？',
      })
      .then(() => {
        // on confirm
        localStorage.removeItem('b_token'); // 清除token
        localStorage.removeItem('routes') // 清除路径
        this.$store.dispatch('user/loginOut');
        // _this.$router.push('/login')
      })
      .catch(() => {
        console.log('点击了取消按钮')
      });


    },
    handleClick(path){
      const page = `/phoneIndex/${path}`;
      this.$router.push(page)
      this.show = false;
    }
  }
}
</script>

<style scoped>
.pageHome {
  /*width: 90%;*/
  height: calc(100vh - 2px);
  margin: 0 auto;
}

.menu {
  display: flex;
  justify-content: space-between;
  margin-bottom: 1em;
  position: fixed;
  z-index: 2;
  top: 0;
  background: #fff;
  width: 90%;
  left: 0;
  box-shadow: 0 10px 10px #ccc;
  padding: 1em 5% 0.2em 5%
}

.van-sidebar{
  width: 100%;
}

.van-sidebar-item--select::before{
  background-color: #2ad1c4;
}

.van-sidebar-item--select {
  color: #2ad1c4;
}

.menu .van-icon{
  /*box-shadow: 0 0 10px #2ad1c4;*/
}

</style>